<template>
    <div class="detailview">
        <div class="detail_title">
            <div class="top" v-if="tableData.articletitle">
                <div class="title">
                    {{tableData.articletitle}}
                </div>
                <p>
                    <span>发布时间：{{tableData.addtime}}</span>
                    <span>阅读数：{{tableData.viewamount}}</span>
                </p>
            </div>

            <div class="detail_c">
                <div class="detail_cont" v-html="tableData.mainbody"></div>

                <div class="detail_bot" v-if="nextPreData">
                    <a
                    v-if="nextPreData.previousnew && nextPreData.previousnew.guid"
                    target="_blank"
                    :href="`/news/${nextPreData.previousnew.guid}?search=${search}`"
                    >
                        上一篇：{{nextPreData.previousnew.articletitle}}
                    </a>

                    <a
                    v-if="nextPreData.nextnew && nextPreData.nextnew.guid"
                    target="_blank"
                    :href="`/news/${nextPreData.nextnew.guid}?search=${search}`"
                    >
                        下一篇：{{nextPreData.nextnew.articletitle}}
                    </a>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    props: {
        tableData: {
            type: Object,
            default: () => {},
        },
        nextPreData: {
            type: Object,
            default: () => {},
        },
    },
    watch: {},
    data() {
        return {};
    },
    computed: {
        search() {
            return this.getQuery('search');
        },
    },
    methods: {
        
    },
    mounted() {
    },
    watch: {},
};
</script>

<style lang="scss" scoped>
@import '@css/var.scss';

.detailview {
    background-color: $whiteColor;
    padding: 30px;
    margin-bottom: 80px;
    .detail_title {
        .top {
            // display: flex;
            .title {
                width: 100%;
                text-align: center;
                font-size: 22px;
                font-weight: bold;
                color: #242424;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
                overflow: hidden;
            }
            p {
                margin: 20px 0;
                text-align: center;
                span {
                    display: inline-block;
                    margin-right: 20px;
                    color: #383838;
                }
            }
        }
        .detail_c {
            ::v-deep .detail_cont {
                min-height: 500px;
                > p {
                    line-height: 40px;
                    text-indent: 2em;
                    margin: 30px 0;
                    font-size: 16px;
                }
                table {
                    margin: 0 auto;
                }
                img {
                    max-width: 720px;
                    margin-left: -20px;
                    text-align: center;
                }
            }

            .detail_bot {
                border-top: 1px solid #d8d8d8;
                padding: 25px 0;

                a {
                    display: block;
                    font-size: 12px;
                    height: 30px;
                    line-height: 30px;
                    margin: 0;
                    padding: 0;
                    color: #383838;

                    &:hover {
                        color: #4078fc;
                        cursor: pointer;
                    }
                }
            }
        }
    }
}
</style>